import React from 'react';
import { default as Components, ComponentMappings } from '../../../components/blocks/components';
import Layout from '../../../components/layout/layout';
import { fetchAPI, assertUpstreamOk } from '../../../lib/api';
import { buildContactSeo, buildContactTitle } from '../../../lib/contact-seo';
import { H1 } from '../../../components/styleguide-remapped/styleguide-remapped';
import settings from '../../../settings.json';
import { uid } from 'react-uid';
import dynamic from 'next/dynamic';
import { PrimaryLayoutWrapper } from '../../../assets/css/style';
const Form = dynamic(() => import('../form'), { ssr: false });

const Contact = ({ contact, contactCategory }) => {
  const pageType = 'CONTACT';

  return (
    <>
      <Layout seo={buildContactSeo(contact.attributes.seo, contactCategory)} key={uid(contact)} hideSearch={false} documentData={contact}>
        <PrimaryLayoutWrapper>
          <H1 className="visually-hidden">{buildContactTitle(contactCategory) ?? 'Kontakt aufnehmen'}</H1>
          {contact.attributes?.contactForm?.length > 0 && <Form {...{ contact: contact.attributes?.contactForm[0], contactCategory: contactCategory }} />}
          {contact.attributes.blockContent && contact.attributes.blockContent.length
            ? contact.attributes.blockContent.map((block, index) => {
              block.id = `${block.__component}-${index}`;
              block.mappingIndex = `comp-${uid(index)}`;

              if (settings.skipableElements.includes(block.__component)) {
                return false;
              }

              return Components(block, contact, pageType);
            })
            : null}
        </PrimaryLayoutWrapper>
      </Layout>
    </>
  );
};

export async function getStaticPaths() {
  const [contactCategoriesRes] = await Promise.all([fetchAPI('/contact-categories')]);

  const paths = [];
  contactCategoriesRes?.data?.forEach((contactCategory) => {
    if (contactCategory.attributes.slug) {
      paths.push({
        params: {
          category: contactCategory.attributes.slug,
        },
      });
    }
  });

  return {
    paths: paths,
    fallback: settings.useFallbackPaths ?? false,
  };
}

export async function getStaticProps({ params }) {
  const [contactCategoriesRes, contactRes] = await Promise.all([
    fetchAPI('/contact-categories', {
      status: 'published',
      filters: {
        slug: params.category,
      },
    }),
    fetchAPI('/contact', { populateDeep: true }),
  ]);

  assertUpstreamOk([contactCategoriesRes], `kontakt ${params.category}`);

  const is404 = !contactCategoriesRes?.data || contactCategoriesRes?.data?.length <= 0;

  return {
    props: {
      contact: contactRes?.data ?? {},
      contactCategory: contactCategoriesRes?.data?.length > 0 ? contactCategoriesRes.data[0] : null,
    },
    revalidate: is404 ? undefined : settings.cacheRefreshSeconds,
    notFound: is404,
  };
}

export default Contact;
